var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.917 35.4167H16.667C10.7744 35.4167 7.82816 35.4167 5.99757 33.5862C4.16699 31.7556 4.16699 28.8093 4.16699 22.9167V20.8334C4.16699 12.9767 4.16699 9.0483 6.60777 6.60752C9.04855 4.16675 12.9769 4.16675 20.8337 4.16675H32.292C37.1558 4.16675 39.5877 4.16675 41.4286 5.15074C42.8822 5.92768 44.0727 7.11821 44.8497 8.57178C45.8337 10.4127 45.8337 12.8446 45.8337 17.7084",
    stroke: "url(#paint0_linear_3571_1781)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.167 31.2501C29.167 27.3217 29.167 25.3575 30.3874 24.1371C31.6078 22.9167 33.572 22.9167 37.5003 22.9167C41.4287 22.9167 43.3929 22.9167 44.6133 24.1371C45.8337 25.3575 45.8337 27.3217 45.8337 31.2501V37.5001C45.8337 41.4285 45.8337 43.3926 44.6133 44.613C43.3929 45.8334 41.4287 45.8334 37.5003 45.8334C33.572 45.8334 31.6078 45.8334 30.3874 44.613C29.167 43.3926 29.167 41.4285 29.167 37.5001V31.2501Z",
    stroke: "url(#paint1_linear_3571_1781)",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5837 41.6667H35.417",
    stroke: "url(#paint2_linear_3571_1781)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.917 45.8333H16.667",
    stroke: "url(#paint3_linear_3571_1781)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.917 45.8334V35.4167",
    stroke: "url(#paint4_linear_3571_1781)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.917 27.0833H4.16699",
    stroke: "url(#paint5_linear_3571_1781)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3571_1781",
    x1: 45.8337,
    y1: 19.7918,
    x2: 4.16699,
    y2: 19.7918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D72128"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3571_1781",
    x1: 45.8337,
    y1: 34.3751,
    x2: 29.167,
    y2: 34.3751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D72128"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3571_1781",
    x1: 39.5837,
    y1: 42.1667,
    x2: 35.417,
    y2: 42.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D72128"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3571_1781",
    x1: 22.917,
    y1: 46.3333,
    x2: 16.667,
    y2: 46.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D72128"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3571_1781",
    x1: 23.917,
    y1: 40.6251,
    x2: 22.917,
    y2: 40.6251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D72128"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3571_1781",
    x1: 22.917,
    y1: 27.5833,
    x2: 4.16699,
    y2: 27.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D72128"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeb);
export default __webpack_public_path__ + "static/media/icon-web.bfd751684b02207432b02118b6ab6efa.svg";
export { ForwardRef as ReactComponent };